'use client';

import Link from 'next/link';
import OrderList from '@/components/account/order-list';
import GuestTrackForm from '@/components/account/guest-track-form';
import { useAuth } from '@/context/auth-context';

export default function TrackOrderClient() {
  const { customer, isLoading } = useAuth();

  return (
    <section className="track-page">
      <div className="container">
        <header className="track-header">
          <h1 className="track-title">Track your order</h1>
          <p className="track-sub">
            {customer
              ? 'Your recent orders and their tracking status.'
              : 'Use the order status link in your confirmation email, or sign in to see your saved orders.'}
          </p>
        </header>

        {isLoading ? (
          <div className="track-loading">Loading order details...</div>
        ) : customer ? (
          <OrderList orders={customer.orders} />
        ) : (
          <>
            <GuestTrackForm />
            <p className="track-signin">
              Have an account?{' '}
              <Link href="/account/login?next=/track-order" className="track-signin-link">
                Sign in
              </Link>{' '}
              to see all of your orders in one place.
            </p>
          </>
        )}
      </div>

      <style>{`
        .track-page {
          padding: 2rem 0 4rem;
          background: var(--color-off-white);
          min-height: 60vh;
        }
        .track-page .container { max-width: 720px; }
        .track-header {
          text-align: center;
          margin-bottom: 2rem;
        }
        .track-title {
          font-size: clamp(1.5rem, 3vw, 2rem);
          font-weight: 700;
          color: var(--color-text-primary);
          margin: 0 0 0.4rem;
        }
        .track-sub {
          font-size: 0.95rem;
          color: var(--color-text-secondary);
          margin: 0;
          max-width: 520px;
          margin-left: auto;
          margin-right: auto;
          line-height: 1.5;
        }
        .track-loading {
          max-width: 420px;
          margin: 0 auto;
          background: var(--color-white);
          border: 1px solid var(--color-border);
          border-radius: 0.75rem;
          padding: 1.5rem;
          text-align: center;
          color: var(--color-text-secondary);
          font-size: 0.9rem;
        }
        .track-signin {
          text-align: center;
          font-size: 0.9rem;
          color: var(--color-text-secondary);
          margin: 1.5rem 0 0;
        }
        .track-signin-link {
          color: var(--color-primary);
          font-weight: 600;
          text-decoration: none;
        }
        .track-signin-link:hover { text-decoration: underline; }
      `}</style>
    </section>
  );
}
